import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import axiosPlugin from './plugins/axios';
import lodashPlugin from './plugins/lodash';
import loadFonts from './plugins/webfontloader';
import router from './router';
import { i18n } from './lang';

loadFonts();

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(vuetify);
app.use(i18n);
app.use(axiosPlugin);
app.use(lodashPlugin);

app.mount('#app');
